import { render, staticRenderFns } from "./report-page.vue?vue&type=template&id=5f8acd44&scoped=true"
import script from "./report-page.vue?vue&type=script&lang=js"
export * from "./report-page.vue?vue&type=script&lang=js"
import style0 from "./report-page.vue?vue&type=style&index=0&id=5f8acd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8acd44",
  null
  
)

export default component.exports